import script from "./AcDivider.vue?vue&type=script&lang=ts&setup=true"
export * from "./AcDivider.vue?vue&type=script&lang=ts&setup=true"

import "./AcDivider.vue?vue&type=style&index=0&id=5085eaef&lang=scss"

const __exports__ = script;

export default __exports__